import { create } from "zustand";

const initialState = {
	user: null,
	organization: null,
};

export const useSessionStore = create((set) => ({
	...initialState,
	updateState: (newState) => set((state) => ({ ...newState })),
	logout: () => {
		window.location = `${process.env.REACT_APP_HOST_PLATFORM}`;
	},
}));
